module.exports = __webpack_public_path__ + "img/CSkirmisher64_ua.d725e08a.webp";